<template>
  <bwr-icon v-bind="$props" :svg-content="svgContent" />
</template>

<script>
import BwrIcon from './BaseIcon.vue'
import svgContent from '@/icons/subscription.svg?raw'
export default {
  name: 'IconSubscription',
  components: {
    BwrIcon,
  },
  data: () => ({ svgContent }),
}
</script>
